/***************************************************************************************************
** buttonCn
***************************************************************************************************/

import cn from "@utils/cn";

const BASE_CN = cn(`
  flex
  items-center
  justify-center
  h-10
  shrink
  gap-2
  py-2
  text-base
  font-medium
  text-nowrap
  min-w-0
  rounded-lg
  border
  outline-hidden
  select-none
  transition-all
  duration-200

  ring-0
  ring-transparent
  border-black/15
  shadow-raised-md

  not-disabled:hover:brightness-110
  not-disabled:focus:ring-2
  not-disabled:focus:outline-hidden
  not-disabled:active:brightness-95
  not-disabled:active:ring-transparent
  not-disabled:active:shadow-pressed-sm

  disabled:opacity-50
  disabled:cursor-not-allowed
`);

const COLOR_CN = {
  default: `
    bg-gallery-50
    text-[#707070]
    border-[#C0C0C0]
    ring-gray-300/50
    shadow-raised-md-light

    not-disabled:hover:brightness-95
    not-disabled:active:brightness-90
    not-disabled:active:shadow-pressed-md-light
  `,
  amaranth: `
    bg-amaranth-600
    ring-amaranth-400/50
    text-white
  `,
  amber: `
    bg-amber-600
    ring-amber-400/50
    text-white
  `,
  blue: `
    bg-blue-600
    ring-blue-400/50
    text-white
  `,
  cyan: `
    bg-cyan-600
    ring-cyan-400/50
    text-white
  `,
  emerald: `
    bg-emerald-600
    ring-emerald-400/50
    text-white
  `,
  fuchsia: `
    bg-fuchsia-600
    ring-fuchsia-400/50
    text-white
  `,
  gallery: `
    bg-gallery-600
    ring-gallery-400/50
    text-white
  `,
  gray: `
    bg-gray-600
    ring-gray-400/50
    text-white
  `,
  green: `
    bg-green-600
    ring-green-400/50
    text-white
  `,
  indigo: `
    bg-indigo-600
    ring-indigo-400/50
    text-white
  `,
  lime: `
    bg-lime-600
    ring-lime-400/50
    text-white
  `,
  neutral: `
    bg-neutral-600
    ring-neutral-400/50
    text-white
  `,
  orange: `
    bg-orange-600
    ring-orange-400/50
    text-white
  `,
  pink: `
    bg-pink-600
    ring-pink-400/50
    text-white
  `,
  purple: `
    bg-purple-600
    ring-purple-400/50
    text-white
  `,
  red: `
    bg-red-600
    ring-red-400/50
    text-white
  `,
  rose: `
    bg-rose-600
    ring-rose-400/50
    text-white
  `,
  sky: `
    bg-sky-600
    ring-sky-400/50
    text-white
  `,
  slate: `
    bg-slate-600
    ring-slate-400/50
    text-white
  `,
  steel: `
    bg-steel-600
    ring-steel-400/50
    text-white
  `,
  stone: `
    bg-stone-600
    ring-stone-400/50
    text-white
  `,
  teal: `
    bg-teal-600
    ring-teal-400/50
    text-white
  `,
  violet: `
    bg-violet-600
    ring-violet-400/50
    text-white
  `,
  yellow: `
    bg-yellow-600
    ring-yellow-400/50
    text-white
  `,
  zinc: `
    bg-zinc-600
    ring-zinc-400/50
    text-white
  `,
};

export default function buttonCn(args) {
  const {
    color = "default",
    isIconOnly = false,
  } = args;

  const additionalClassNames = cn({
    "h-10 w-11": isIconOnly,
    "px-2.5": isIconOnly,
    "px-4": !isIconOnly,
  });

  return cn(BASE_CN, COLOR_CN[color], additionalClassNames, args.className);
}
